<!-- 
	This is the Dashboards CRM page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
	<div>

		<!-- Charts -->
		<a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :lg="16">

				<a-row :gutter="24" type="flex" align="stretch">
					<a-col :span="12" class="mb-24">

						<!-- Your Transactions Card -->
						<CardTransactions2 title="Completed Recipes" date="" :data="transactionsData">
						</CardTransactions2>
						<!-- / Your Transactions Card -->

					</a-col>
					<a-col :span="12" class="mb-24">

						<!-- Revenue Card -->
						<CardTransactions2 title="Saved" :data="transactionsData2" date="">
						</CardTransactions2>
						<!-- / Revenue Card -->

					</a-col>
					<!-- Calendar -->

					<a-col :span="24" :lg="8">
						<h6>Completed Customer Recipes</h6>
					</a-col>
					<!-- Orders List card -->
					<a-card :bordered="false" class="custom-card header-solid mb-24"
						:bodyStyle="{ padding: 0, paddingTop: '16px' }">
						<!-- Table search -->
						<div class="mx-25">
							<a-row type="flex" :gutter="24">
								<a-col :span="24" class="text-right">
									<a-input-search placeholder="Search for Recipe" style="max-width: 200px;"
										v-model="query" @change="onSearchChange" />
								</a-col>
							</a-row>
						</div>
						<!-- / Table search -->

						<!-- Orders table -->
						<a-table class="mt-20" :columns="columns" :data-source="data" :pagination="{ pageSize: pageSize, }"
							:rowKey="record => record.id">

							<template slot="id" slot-scope="id">#{{ id }}</template>

							<template slot="status" slot-scope="status">
								<span style="vertical-align: middle;">{{ status }}</span>
							</template>

							<template slot="customer" slot-scope="customer">
								<div class="table-avatar-info">
									<!-- <a-avatar v-if="customer.avatar" shape="circle" :size="24" :src="customer.avatar" />
									<a-avatar v-else shape="circle" :size="24">{{ customer.slice(0, 1) }}</a-avatar> -->
									<div class="avatar-info">
										<p class="mb-0 text-dark">{{ customer }}</p>
									</div>
								</div>
							</template>

							<template slot="product" slot-scope="text, record">
								<a-button @click="generateDocumentRational(record.id, record.recipeName)" :disabled="isDownloading"
									:loading="isDownloading">
									<svg width="15" height="15" viewBox="0 0 20 20" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
											fill="#111827" />
									</svg>
									Word
								</a-button>
							</template>

							<template slot="revenue" slot-scope="text, record">
								<a-button @click="generateDocumentSDS(record.id, record.recipeName)" :disabled="isDownloading"
									:loading="isDownloading">
									<svg width="15" height="15" viewBox="0 0 20 20" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
											fill="#111827" />
									</svg>
									Word
								</a-button>

							</template>

							<template slot="label" slot-scope="text, record">
								<a-button @click="generateDocumentLabel(record.id, record.recipeName)" :disabled="isDownloading"
									:loading="isDownloading">
									<svg width="15" height="15" viewBox="0 0 20 20" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd" clip-rule="evenodd"
											d="M3 17C3 16.4477 3.44772 16 4 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17ZM6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L9 10.5858L9 3C9 2.44772 9.44771 2 10 2C10.5523 2 11 2.44771 11 3L11 10.5858L12.2929 9.29289C12.6834 8.90237 13.3166 8.90237 13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73478 14 9.48043 13.8946 9.29289 13.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289Z"
											fill="#111827" />
									</svg>
									Word
								</a-button>

							</template>

							<template slot="editBtn" slot-scope="row">

								<a-button :data-id="row.key" :disabled="isDownloading" :loading="isDownloading"
									@click="$router.push({ name: 'UpdateRecipe', params: { id: row.id } })">
									<a-icon type="edit" theme="outlined" /> Edit
								</a-button>

							</template>

						</a-table>
						<!-- / Orders table -->

					</a-card>
					<!-- / Orders List card -->

				</a-row>

			</a-col>
			<a-col :span="24" :lg="8">

				<a-card :bordered="false" class="header-solid mb-24">
					<template #title>
						<h6 class="font-semibold m-0">Start new recipe</h6>
						<p>Learn more about the recipe configurations on the admin <a href="">Dashboard</a>. </p>
						<br />
						<p><a-button type="primary" @click="$router.push('../recipe/newrecipe')" size="large">START RECIPE</a-button>
						</p>

					</template>
				</a-card>

				

			</a-col>
		</a-row>

		<!-- / Charts -->

	</div>
</template>

<script>

// Bar chart for Visitors card.
import WidgetLineChart from '../../components/Widgets/WidgetLineChart';

// Information card 2.
import CardInfo2 from '../../components/Cards/CardInfo2';

// Notification Card
import CardNotification from "../../components/Cards/CardNotification"

// Categories List Card
import CardCategories from '../../components/Cards/CardCategories';

// Transactions List Card
import CardTransactions2 from '../../components/Cards/CardTransactions2';

// Sorting function for string attibutes.
let stringSorter = function (a, b, attr) {
	if (a[attr] < b[attr])
		return -1;
	if (a[attr] > b[attr])
		return 1;
	return 0;
}

// Table columns
const columns = [
	{
		title: 'ID',
		dataIndex: 'id',
		sorter: (a, b) => a.id - b.id,
		sortDirections: ['descend', 'ascend'],
		scopedSlots: { customRender: 'id' },
	},
	{
		title: 'Recipe Name',
		dataIndex: 'recipeName',
		sorter: (a, b) => a.updatedDate.length - b.updatedDate.length,
		sortDirections: ['descend', 'ascend']
	},
	{
		title: 'CUSTOMER',
		dataIndex: 'customerName',
		// sorter(a, b, attr) {
		// 	if (a.customer < b.customer)
		// 		return -1;
		// 	if (a.customer > b.customer)
		// 		return 1;
		// 	return 0;
		// },
		sortDirections: ['descend', 'ascend'],
		scopedSlots: { customRender: 'customer' },
	},
	{
		title: 'STATUS',
		dataIndex: 'recipeStatus',
		sorter: (a, b) => stringSorter(a, b, 'recipeStatus'),
		sortDirections: ['descend', 'ascend'],
		scopedSlots: { customRender: 'recipeStatus' },
	},
	{
		title: 'Last updated',
		dataIndex: 'updatedDate',
		sorter: (a, b) => a.updatedDate.length - b.updatedDate.length,
		sortDirections: ['descend', 'ascend'],
		customRender: (text) => {
			return text.split(' ')[0];
		}
	},
	{
		title: 'Rational',
		// dataIndex: 'product',
		scopedSlots: { customRender: 'product' },
	},
	{
		title: 'SDS',
		// dataIndex: 'revenue',
		scopedSlots: { customRender: 'revenue' },
	},
	{
		title: 'Label',
		// dataIndex: 'revenue',
		scopedSlots: { customRender: 'label' },
	},
	{
		title: 'Actions',
		scopedSlots: { customRender: 'editBtn' },
	},
];

const data = [];

const categoriesData = [
	{
		id: "1",
		title: "Your Custom Recipe Name 1",
		subtitle: "<span class='font-weight-bold'>2.3.4 (30) +0.5%Zn</span>",
		icon: 'gitlab',
	},
	{
		id: "2",
		title: "Your Custom Recipe Name 2",
		subtitle: "<span class='font-weight-bold'>1.3.4 (30) +0.7%LAN28</span>",
		icon: 'gitlab',
	},
	{
		id: "3",
		title: "Your Custom Recipe Name 3",
		subtitle: "<span class='font-weight-bold'>1.3.4 (30) +0.9%MKP</span>",
		icon: 'gitlab',
	},
];

const transactionsData = [];

// "Your Transactions" list data.
const transactionsData2 = [];


export default ({
	components: {
		WidgetLineChart,
		CardInfo2,
		CardNotification,
		CardCategories,
		CardTransactions2,
	},
	data() {
		return {
			isDownloading: false,
			transactionsData,
			transactionsData2,
			categoriesData,
			// Table columns
			columns,

			// Table rows
			data,

			// Table page size
			pageSize: 10,

			// Table search query
			query: '',

			// Table's selected rows
			selectedRowKeys: [],

		}
	},
	computed: {
		recipes: {
			get() {
				return this.$store.state.recipes.recipes;
			}
		},
		user: {
			get() {
				return this.$store.state.user.user;
			}
		},
		// Current date for calendar.
		date() {
			var today = new Date();
			var mYear = today.getFullYear();
			var weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
			var mDay = weekday[today.getDay()];

			return `${mDay}, ${mYear}`;
		},
		// CSV data array
		csvData() {
			return this.data.map(item => ({
				"Id": "%23" + item.key,
				"Date": item.date,
				"Status": item.status,
				"Customer": item.customer.name,
				"Product": item.product,
				"Revenue": item.revenue,
			}));
		},
	},
	created() {
		this.$store.dispatch('recipes/getAll').then(() => {

			// Save all the recipes
			this.data = this.recipes;

			// Sort the recipes by their created date
			this.data.sort((a, b) => {
				// Convert the createdDate strings to Date objects
				const dateA = new Date(a.createdDate);
				const dateB = new Date(b.createdDate);

				// Compare the Date objects
				return dateA - dateB;
			});

			// Update the 2 cards at the top
			this.transactionsData = [];
			this.transactionsData2 = [];

			// Obtain the first 3 recipes by their statusId
			const first3CompletedRecipes = this.data.filter(recipe => recipe.recipeStatusId == 1).splice(0, 3);
			const first3SavedRecipes = this.data.filter(recipe => recipe.recipeStatusId == 2).splice(0, 3);

			// Add them to the data references and update the UI
			for (const recipe of first3CompletedRecipes) {
				this.transactionsData.push({
					title: recipe.recipeName,
					datetime: new Date(recipe.createdDate).toLocaleString(),
					amount: recipe.customerName,
					type: recipe.recipeStatusId,
					status: recipe.recipeStatus,
				})
			}

			for (const recipe of first3SavedRecipes) {
				this.transactionsData2.push({
					title: recipe.recipeName,
					datetime: new Date(recipe.createdDate).toLocaleString(),
					amount: recipe.customerName,
					type: recipe.recipeStatusId,
					status: recipe.recipeStatus,
				})
			}
		})
	},
	methods: {
		async generateDocumentRational(id, recipeName) {
			console.log('rationale', { id: id, recipeName: recipeName });
			this.isDownloading = true;
			this.$store.dispatch("WordDocs/getRational", { id: id, recipeName: recipeName }).then(() => {
				this.isDownloading = false;
			});
		},

		async generateDocumentSDS(id, recipeName) {
			console.log('sds', { id: id, recipeName: recipeName });
			this.isDownloading = true;
			this.$store.dispatch("WordDocs/getSDS", { id: id, recipeName: recipeName }).then(() => {
				this.isDownloading = false;
			});
		},

		async generateDocumentLabel(id, recipeName) {
			console.log('label', { id: id, recipeName: recipeName });
			this.isDownloading = true;
			this.$store.dispatch("WordDocs/getLabel", { id: id, recipeName: recipeName }).then(() => {
				this.isDownloading = false;
			});
		},
		// Event listener for input change on table search field.
		onSearchChange() {
			const trimmedQuery = this.query.trim().toLowerCase();
			if (trimmedQuery.length > 0) {
				this.data = this.data.filter((row) => {
					for (const key in row) {
						if (row[key] && row[key].toString().toLowerCase().includes(trimmedQuery)) {
							return true;
						}
					}
					return false;
				});
			} else if (trimmedQuery.length === 0) { // Corrected this line
				this.data = this.recipes;
			} else {
				this.data = data;
			}
		},

		// Event listener for table row selection change.
		onSelectChange(selectedRowKeys) {
			this.selectedRowKeys = selectedRowKeys;
		},

		// Export table in CSV format.
		csvExport(arrData) {
			let csvContent = "data:text/csv;charset=utf-8,";
			csvContent += [
				Object.keys(arrData[0]).join("|"),
				...arrData.map(item => Object.values(item).join("|"))
			]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");

			const data = encodeURI(csvContent);
			const link = document.createElement("a");
			link.setAttribute("href", data);
			link.setAttribute("download", "muse-dashboard-csv.csv");
			link.click();
		}

	},
})

</script>

<style lang="scss" scoped>
.table-avatar-info {
	display: flex;
	align-items: center;
}

.table-avatar-info .ant-avatar {
	margin-right: 8px;
}

// Using vuejs "Deep Selectors"
.table-avatar-info::v-deep .ant-avatar-string {
	font-size: 12px;
}

.btn-status::v-deep .anticon {
	line-height: 0;
}

.custom-card {
	width: 100%;
	/* You can adjust this value as needed */
}
</style>